var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-item",class:_vm.msg.type},[_c('span',[_vm._v(_vm._s(_vm.msg.content))]),_c('span',{staticClass:"close",on:{"click":_vm.handleClose}},[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }